import React from 'react';
import { NavLink as ReactRouterNavLink } from 'react-router-dom';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface NavLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>, ForwardedHTMLProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  activeClassName?: string;
}

export const NavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ to, children, className, activeClassName, ...props }, _ref) => {
    const tef = useTEF();
    const forwardedProps = forwardProps(props);

    const baseClasses = cn(
      tef.colors.foregroundSecondary,
      'hover:text-slate-900 dark:hover:text-slate-100',
      'transition-colors',
      className
    );

    const activeClasses = activeClassName || cn(tef.colors.primary, 'font-semibold');

    return (
      <ReactRouterNavLink
        to={to}
        className={({ isActive }) => cn(baseClasses, isActive && activeClasses)}
        {...forwardedProps}
        {...props}
      >
        {children}
      </ReactRouterNavLink>
    );
  }
);

NavLink.displayName = 'NavLink';
